import { render, staticRenderFns } from "./filteredReviews.vue?vue&type=template&id=227c88a4&scoped=true"
import script from "./filteredReviews.vue?vue&type=script&lang=js"
export * from "./filteredReviews.vue?vue&type=script&lang=js"
import style0 from "./filteredReviews.vue?vue&type=style&index=0&id=227c88a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227c88a4",
  null
  
)

export default component.exports